// extracted by mini-css-extract-plugin
export default {"container":"InputSearch_container__Rna2N","title":"InputSearch_title__KEtPP","input":"InputSearch_input__5bs+S","findIcon":"InputSearch_findIcon__lrBzD"};